export const AddFolder = ({ size = 22, className, bold }) => {
  return bold ? (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.33333 2.6665H6L8 4.6665H12.6667C13.403 4.6665 14 5.26346 14 5.99984V11.3332C14 12.0696 13.403 12.6665 12.6667 12.6665H3.33333C2.59695 12.6665 2 12.0696 2 11.3332V3.99984C2 3.26346 2.59695 2.6665 3.33333 2.6665"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99935 6.6665V10.6665"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 8.66683H10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.58333 3.66699H8.25L11 6.41699H17.4167C18.4292 6.41699 19.25 7.2378 19.25 8.25033V15.5837C19.25 16.5962 18.4292 17.417 17.4167 17.417H4.58333C3.57081 17.417 2.75 16.5962 2.75 15.5837V5.50033C2.75 4.4878 3.57081 3.66699 4.58333 3.66699"
        stroke="currentColor"
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9993 9.16699V14.667"
        stroke="currentColor"
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.25 11.9163H13.75"
        stroke="currentColor"
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
